import React, {useState} from 'react'
import PropTypes from 'prop-types';
import ProcedureSection from "./ProcedureSection";
import ExclusionSection from "./ExclusionSection";
import SelectionSection from "./SelectionSection";
import DealingJedzSection from "./components/DealingJedzSection";
import Confirm from "components/popup/confirm/Confirm";
import EspdService from "services/EspdService";
import GridBlock from "components/GridBlock";
import RadioGroup from "components/RadioGroup";
import BooleanItems from "constants/BooleanItems";
import Tr from "translations/Translations";
import ExportJedzButtons from "./components/ExportJedzButtons";
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";
import {Typography} from "@material-ui/core";
import clsx from "clsx";
import Button from "components/Button";
import Dialog from "components/Dialog";
import getObjectValue from 'libs/getObjectValue';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyle = makeStyles((theme) => ({
    buttonRow: {
        marginTop: theme.spacing(1),
        textAlign: "end"
    }
}));

const defaultConfirmData = {open: false, demandId: undefined, dealingId: undefined, type: undefined};

function JEDZFormContent(
    {
        formikProps,
        demandId,
        handleJedzTypeChange,
        sectionCompleted
    }) {

    const classes = useStyle();
    const [confirmPopupData, setConfirmPopupData] = useState(defaultConfirmData);
    const [downloadingInProgress, setDownloadingInProgress] = useState(false);

    const isSectorBuyer = (buyerType) => {
        return 'SECTOR' === buyerType;
    }

    const exportTemplate = ({demandId, dealingId, type}) => {

        setDownloadingInProgress(true);
        if (type === 'xml') {
            EspdService.exportXML(demandId, dealingId).finally(() => {
                setDownloadingInProgress(false);
            })
        } else if (type === 'pdf') {
            EspdService.exportPDF(demandId, dealingId).finally(() => {
                setDownloadingInProgress(false);
            })
        }
        setConfirmPopupData(defaultConfirmData);
    }

    const handleBuyerTypeChanged = (newBuyerType, fieldPath) => {
        if (!isSectorBuyer(newBuyerType)) {
            for (let s of ['e1', 'e2']) {
                const elements = getObjectValue(`${fieldPath}.${s}`, formikProps.values);
                for (let key in elements) {
                    if (!elements[key])
                        formikProps.setFieldValue(`${fieldPath}.${s}.${key}`, true);
                }
            }
        }
    }

    const separateForDealing = formikProps.values.separateForEachDealing === 'true';
    const idPrefix = separateForDealing ? 'espds' : 'espd';
    let demandSectorBuyer = separateForDealing ? false : isSectorBuyer(formikProps.values.espd.espdBuyerType);
    return (
        <>
            <GridBlock justify='space-between'>
                <RadioGroup
                    id='separateForEachDealing'
                    items={BooleanItems}
                    formikProps={formikProps}
                    label={Tr('jedz_separate_for_each_dealing')}
                    onChange={() => handleJedzTypeChange(!separateForDealing)}
                />
                {!separateForDealing && <ExportJedzButtons demandId={demandId} setConfirmPopupData={setConfirmPopupData}/>}
            </GridBlock>

            {separateForDealing ?
                <>
                    {formikProps.values.espds.map((el, index) => {
                        const dealingIdPrefix = `${idPrefix}.${index}`;
                        let dealingSectorBuyer = isSectorBuyer(el.espdBuyerType);
                        return <DealingJedzSection key={el.identity} idPrefix={dealingIdPrefix} title={el.name} index={index} dealingId={el.identity} demandId={demandId}
                                                   setConfirmPopupData={setConfirmPopupData} sectionCompleted={sectionCompleted} formikProps={formikProps}>
                            <ProcedureSection formikProps={formikProps} idPrefix={dealingIdPrefix} onBuyerTypeChanged={(event) => handleBuyerTypeChanged(event.target.value, dealingIdPrefix)}/>
                            <ExclusionSection formikProps={formikProps} idPrefix={dealingIdPrefix} sectorBuyer={dealingSectorBuyer} />
                            <SelectionSection formikProps={formikProps} idPrefix={dealingIdPrefix} />
                        </DealingJedzSection>
                    })}
                </>
                :
                <>
                    <ProcedureSection formikProps={formikProps} idPrefix={idPrefix} onBuyerTypeChanged={(event) => handleBuyerTypeChanged(event.target.value, idPrefix)}/>
                    <ExclusionSection formikProps={formikProps} idPrefix={idPrefix} sectorBuyer={demandSectorBuyer}/>
                    <SelectionSection formikProps={formikProps} idPrefix={idPrefix}/>
                </>
            }

            <Dialog
                open={!sectionCompleted && confirmPopupData.open}
                titleCentered
                maxWidth={'sm'}
                onClose={() => setConfirmPopupData(defaultConfirmData)}
            >
                <Typography>
                    {Tr('make_sure_section_save')}
                </Typography>
                <div className={clsx(classes.buttonRow, classes.dropzone)}>
                    <Button
                        onClick={() => setConfirmPopupData(defaultConfirmData)}
                    >
                        {Tr('close')}
                    </Button>
                </div>
            </Dialog>

            <Confirm
                confirmText='make_sure_section_save'
                onCancel={() => setConfirmPopupData(defaultConfirmData)}
                onConfirm={() => exportTemplate(confirmPopupData)}
                open={sectionCompleted && confirmPopupData.open}
                labelConfirm='export'
                labelCancel='cancel'
            />
            {downloadingInProgress && <LoadingScreen/>}
        </>
    )
}

JEDZFormContent.propTypes = {
    classes: PropTypes.any,
}

export default JEDZFormContent;
